<template>
    <div class="mt-3">
        <input
            ref="input"
            type="file"
            class="d-none"
            name="uploadImage"
            accept="image/*"
            v-on:change="setImage"
        />

        <div class="d-flex justify-content-center">
            <section class="cropper-area">
                <div class="img-cropper">
                    <vue-cropper
                        ref="cropper"
                        :aspect-ratio="1"
                        :src="image_url"
                    />
                </div>
                <div class="d-flex justify-content-center">
                    <button
                        role="button"
                        class="btn btn-sm btn-outline-dark m-1"
                        @click.prevent="showFileChooser"
                    >
                        Upload Image
                    </button>
                    <button
                        class="btn btn-sm btn-outline-dark m-1"
                        role="button"
                        @click.prevent="cropImage"
                    >
                        Crop
                    </button>
                    <button
                        class="btn btn-sm btn-outline-dark m-1"
                        role="button"
                        @click.prevent="reset"
                    >
                        Reset
                    </button>

                </div>
            </section>
            <section class="preview-area">
                <div class="cropped-image">
                    <img
                        width="318"
                        v-if="cropImg"
                        :src="cropImg"
                        alt="Cropped Image"
                    />
                </div>
                <div v-if="cropImg" class="d-flex justify-content-center">
                    <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="floatingInput" placeholder="fileName" ref="fileName">
                        <label for="floatingInput">Nume imagine</label>
                    </div>
                    <button
                        class="btn btn-sm btn-outline-dark m-1"
                        role="button"
                        @click.prevent="saveImage"
                    >
                        Save
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    props: ['image_url', 'productId'],
    components: {
        VueCropper,
    },
    data() {
        return {
            cropImg: '',
            data: null,
            loading: false
        };
    },
    methods: {
        cropImage() {
            // get image data for post processing, e.g. upload or setting image src
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
        flipX() {
            const dom = this.$refs.flipX;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleX(scale);
            dom.setAttribute('data-scale', scale);
        },
        flipY() {
            const dom = this.$refs.flipY;
            let scale = dom.getAttribute('data-scale');
            scale = scale ? -scale : -1;
            this.$refs.cropper.scaleY(scale);
            dom.setAttribute('data-scale', scale);
        },
        getCropBoxData() {
            this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
        },
        getData() {
            this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
        },
        move(offsetX, offsetY) {
            this.$refs.cropper.move(offsetX, offsetY);
        },
        reset() {
            this.$refs.cropper.reset();
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);
        },
        setCropBoxData() {
            if (!this.data) return;

            this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
        },
        setData() {
            if (!this.data) return;

            this.$refs.cropper.setData(JSON.parse(this.data));
        },
        setImage(e) {
            const file = e.target.files[0];

            if (file.type.indexOf('image/') === -1) {
                alert('Please select an image file');
                return;
            }

            if (typeof FileReader === 'function') {
                const reader = new FileReader();

                reader.onload = (event) => {
                    this.image_url = event.target.result;
                    // rebuild cropperjs with the updated source
                    this.$refs.cropper.replace(event.target.result);
                };

                reader.readAsDataURL(file);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        },
        saveImage() {
            this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()
            this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                let formData = new FormData();
                // always png
                formData.append('image', blob, 'something.png')
                formData.append('imageName', this.$refs.fileName.value)
                window.axios.post('/admin/products/' + this.productId + '/upload', formData)
                .then(function() {
                }).catch(function() {
                });
            })

        },
        showFileChooser() {
            this.$refs.input.click();
        },
        zoom(percent) {
            this.$refs.cropper.relativeZoom(percent);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
